import { render, staticRenderFns } from "./createOfferFields.vue?vue&type=template&id=4bdfd71b&"
import script from "./createOfferFields.vue?vue&type=script&lang=ts&"
export * from "./createOfferFields.vue?vue&type=script&lang=ts&"
import style0 from "./createOfferFields.vue?vue&type=style&index=0&id=4bdfd71b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports